import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useLocation } from "react-router-dom";
import Hero from "../components/Hero/Hero";
import AboutMe from "../components/AmoutMe/AboutMe";
import BasicRules from "../components/BasicRules/BasicRules";
import Gallery from "../components/Gallery/Gallery";
import Contact from "../components/Contact/Contact";

const HomePage = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const location = useLocation();

  // Sync language with URL parameter
  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  // Handle section scrolling based on route
  useEffect(() => {
    const pathSegments = location.pathname
      .split("/")
      .filter((segment) => segment);

    if (pathSegments.length >= 2) {
      const section = pathSegments[1];

      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location.pathname, lang]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <Hero onCTAClick={scrollToSection} />
      <AboutMe id="about-me" onCTAClick={scrollToSection} />
      <BasicRules id="basic-rules" />
      <Gallery id="gallery" />
      <Contact id="contact" t={t} />
    </>
  );
};

export default HomePage;
